import { createContext, useContext } from 'react';
import { dapiFetchWithLogging } from '@origin-digital/sales-common-types-fns';

/**
 * Context for providing a fetch function throughout the component tree.
 * Defaults to dapiFetchWithLogging from sales-common-types-fns, which wraps
 * dapiFetch with NR logging and injects trace headers. Override via provider
 * for testing.
 */
const FetchContext = createContext(dapiFetchWithLogging);

/**
 * Hook to access the fetch function from context.
 * @returns The fetch function (dapiFetch by default, or overridden via provider)
 */
export const useFetch = () => useContext(FetchContext);

/**
 * Provider component for overriding the default fetch function.
 * Useful for testing scenarios where you want to mock API calls
 * or provide a different fetch implementation.
 */
export const FetchProvider = FetchContext.Provider;
